export default __webpack_public_path__ + "static/media/undraw_growth_chart.da981913.svg";